import { render } from "./BulkAddEditStudentsNew.vue?vue&type=template&id=7db10fe4"
const script = {}

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__